import { Controller } from "@hotwired/stimulus"

// Right-side slideout. Content is loaded into its <turbo-frame> by any link that targets the frame
// (data-turbo-frame="help_drawer"); the drawer opens itself when the frame finishes loading, so a
// "Learn more" / "Setup guide" link anywhere on the page pops the guide open in context instead of
// navigating away. Closes on overlay click, the close button, or Escape.
export default class extends Controller {
  static targets = ["panel", "overlay", "frame"]

  connect() {
    this.openOnFrameLoad = () => this.open()
    this.closeOnEscape = (event) => {
      if (event.key === "Escape") this.close()
    }
    if (this.hasFrameTarget) {
      this.frameTarget.addEventListener("turbo:frame-load", this.openOnFrameLoad)
    }
  }

  disconnect() {
    if (this.hasFrameTarget) {
      this.frameTarget.removeEventListener("turbo:frame-load", this.openOnFrameLoad)
    }
    document.removeEventListener("keydown", this.closeOnEscape)
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    clearTimeout(this.hideAfterTransition)
    this.element.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.overlayTarget.classList.remove("opacity-0")
      this.panelTarget.classList.remove("translate-x-full")
    })
    document.addEventListener("keydown", this.closeOnEscape)
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.overlayTarget.classList.add("opacity-0")
    this.panelTarget.classList.add("translate-x-full")
    document.removeEventListener("keydown", this.closeOnEscape)
    document.body.classList.remove("overflow-hidden")
    this.hideAfterTransition = setTimeout(() => this.element.classList.add("hidden"), 300)
  }
}
